import { useEffect, useRef, useState } from "react";
import API from "../axios";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";

const CreateVehicle = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [productPhotoUploading, setProductPhotoUploading] = useState(false);
    const [galleryPhotoUploading, setGalleryPhotoUploading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);

    // Form fields
    const [title, setTitle] = useState("");
    const [sku, setSku] = useState("");
    const [productShortDescription, setProductShortDescription] = useState("");
    const [productDescription, setProductDescription] = useState("");

    // Pricing
    const [regularPrice, setRegularPrice] = useState("");
    const [discountPrice, setDiscountPrice] = useState("");
    const [factoryPrice, setFactoryPrice] = useState("");

    // Stock
    const [stockCount, setStockCount] = useState("");
    const [stockStatus, setStockStatus] = useState("");
    const [enableTracking, setEnableTracking] = useState(false);

    // Photos
    const [productImage, setProductImage] = useState<any>("");
    const [productGallery, setProductGallery] = useState<any>([]);
    const [currentUpload, setCurrentUpload] = useState("product");

    const tabs = ["Vehicle Price", "Stock", "Specification"];
    const [activeTab, setActiveTab] = useState("Vehicle Price");

    const fileUploadRef = useRef<any>(null);

    const handleFileChange = async (e: any) => {
        const file = e.target.files[0];

        if (file) {
            if (currentUpload == "product") {
                setProductPhotoUploading(true);

                const result: any = await API.upload(
                    file,
                    "xcess.com/vehicles"
                );
                setProductImage(result.fileUrl);

                setProductPhotoUploading(false);
            } else {
                setGalleryPhotoUploading(true);

                const result: any = await API.upload(
                    file,
                    "xcess.com/vehicles"
                );
                setProductGallery([...productGallery, result.fileUrl]);

                setGalleryPhotoUploading(false);
            }
        }
    };

    const handleSave = async function () {
        setSaveLoading(true);

        const data = {
            title,
            sku,
            productShortDescription,
            productDescription,
            regularPrice: !!regularPrice ? parseFloat(regularPrice) : null,
            discountPrice: !!discountPrice ? parseFloat(discountPrice) : null,
            factoryPrice: !!factoryPrice ? parseFloat(factoryPrice) : null,
            productImage,
            productGallery,
        };

        await API.createVehicle(data);

        setSaveLoading(false);
    };

    return (
        <div>
            {loading ? (
                <div className="d-flex justify-content-center my-5">
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            ) : (
                <Container style={{ marginTop: 100, paddingBottom: 200 }}>
                    {/* Header */}
                    <Row className="mb-5">
                        <Col
                            cols="6"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                gap: 10,
                            }}
                        >
                            <a
                                type="button"
                                className="btn btn-outline-black btn-md mx-1"
                                href="/vehicles"
                            >
                                <i className="bi bi-chevron-left"></i>
                            </a>
                            <h5 className="h5">Create Vehicle</h5>
                        </Col>
                        <Col cols="6" className="text-end">
                            <button
                                type="button"
                                className="btn btn-primary mx-1"
                                onClick={handleSave}
                                disabled={saveLoading}
                            >
                                <i className="bi bi-save mx-2"></i>
                                {saveLoading ? "Saving..." : "Save"}
                            </button>
                        </Col>
                    </Row>

                    {/* Vehicle Info */}
                    <Row>
                        <Col xs="12" md="8">
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Vehicle Name
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter product name"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    SKU
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter sku"
                                    value={sku}
                                    onChange={(e) => setSku(e.target.value)}
                                />
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Short Description
                                </label>
                                <textarea
                                    className="form-control"
                                    name="short-descripton"
                                    placeholder="Enter short description"
                                    rows={3}
                                    value={productShortDescription}
                                    onChange={(e) =>
                                        setProductShortDescription(
                                            e.target.value
                                        )
                                    }
                                ></textarea>
                            </div>
                            <div className="py-3">
                                <label className="form-label fw-bold">
                                    Description
                                </label>
                                <textarea
                                    className="form-control"
                                    name="short-descripton"
                                    placeholder="Enter short description"
                                    rows={7}
                                    value={productDescription}
                                    onChange={(e) =>
                                        setProductDescription(e.target.value)
                                    }
                                ></textarea>
                            </div>

                            <div className="divider"></div>

                            <ul className="nav nav-tabs mt-5">
                                {tabs.map((tab) => (
                                    <li
                                        key={tab}
                                        className="nav-item"
                                        onClick={() => setActiveTab(tab)}
                                        style={{
                                            cursor: "pointer",
                                        }}
                                    >
                                        <a
                                            className={`nav-link ${
                                                tab == activeTab ? "active" : ""
                                            }`}
                                            aria-current="page"
                                            style={{
                                                fontSize: 14,
                                                fontWeight: "500",
                                            }}
                                        >
                                            {tab}
                                        </a>
                                    </li>
                                ))}
                            </ul>

                            {/* Price */}
                            {activeTab == "Vehicle Price" && (
                                <Row className="mt-3">
                                    <Col xs="6">
                                        <div className="py-3">
                                            <label className="form-label fw-bold">
                                                Regular Price
                                            </label>
                                            <br />
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter price"
                                                value={regularPrice}
                                                onChange={(e) =>
                                                    setRegularPrice(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                            <small className="text-dark-subtle">
                                                The regular is used for normal
                                                price without discount or any
                                                other conditions.
                                            </small>
                                        </div>
                                    </Col>
                                    <Col xs="6">
                                        <div className="py-3">
                                            <label className="form-label fw-bold">
                                                Discount Price
                                            </label>
                                            <br />
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter price"
                                                value={discountPrice}
                                                onChange={(e) =>
                                                    setDiscountPrice(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                            <small className="text-dark-subtle">
                                                Discount price will calcuate
                                                with when the value is not
                                                empty.
                                            </small>
                                        </div>
                                    </Col>
                                    <Col xs="6">
                                        <div className="py-3">
                                            <label className="form-label fw-bold">
                                                Factory Price
                                            </label>
                                            <br />
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter price"
                                                value={factoryPrice}
                                                onChange={(e) =>
                                                    setFactoryPrice(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            )}

                            {/* Stock */}
                            {activeTab == "Stock" && (
                                <Row className="mt-3">
                                    <Col xs="6">
                                        <div className="py-3">
                                            <label className="form-label fw-bold">
                                                Stock Count
                                            </label>
                                            <br />
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Enter current stock count"
                                                value={stockCount}
                                                onChange={(e) =>
                                                    setStockCount(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                    </Col>
                                    <Col xs="6">
                                        <div className="py-3">
                                            <label className="form-label fw-bold">
                                                Stock Status
                                            </label>
                                            <br />

                                            <select
                                                className="form-select"
                                                aria-label="Default select example"
                                                value={stockStatus}
                                                onChange={(e) =>
                                                    setStockStatus(
                                                        e.target.value
                                                    )
                                                }
                                            >
                                                <option value="in_stock">
                                                    In Stock
                                                </option>
                                                <option value="out_of_stock">
                                                    Out Of Stock
                                                </option>
                                            </select>
                                        </div>
                                    </Col>
                                    <Col xs="6">
                                        <div className="form-check py-3">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                value=""
                                                id="checkChecked"
                                                checked={
                                                    enableTracking as boolean
                                                }
                                                onChange={(e) =>
                                                    setEnableTracking(
                                                        e.target.checked
                                                    )
                                                }
                                            />
                                            <label className="form-check-label">
                                                Enable tracking
                                            </label>
                                        </div>
                                        <small>
                                            <i>
                                                When you enable this after every
                                                successful purchase the stock
                                                count will reduced.
                                            </i>
                                        </small>
                                    </Col>
                                </Row>
                            )}
                        </Col>
                        <Col xs="12" md="4" className="p-y-2">
                            <div>
                                <div className="d-flex flex-row justify-content-between">
                                    <label className="form-label fw-bold">
                                        Product Photo
                                    </label>
                                    <button
                                        type="button"
                                        className="btn btn-grey btn-sm mx-1"
                                        onClick={() => setProductImage("")}
                                    >
                                        <i className="bi bi-trash"></i>
                                    </button>
                                </div>
                                {productImage ? (
                                    <img
                                        src={`https://website.carandx.com/_next/image?url=%2Fimages%2Fvehicle_1.jpg&w=640&q=75`}
                                        width="100%"
                                        className="rounded-2"
                                    />
                                ) : (
                                    <>
                                        <div
                                            className="bg-body-secondary rounded-2 d-flex justify-content-center align-items-center"
                                            style={{
                                                width: "100%",
                                                height: 250,
                                                cursor: "pointer",
                                            }}
                                            onClick={() => {
                                                fileUploadRef.current?.click();
                                                setCurrentUpload("product");
                                            }}
                                        >
                                            <i className="bi bi-upload mx-3"></i>
                                            <small>
                                                {productPhotoUploading
                                                    ? "Uploading ..."
                                                    : "Upload new photo"}
                                            </small>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="divider"></div>
                            <div className="mt-3">
                                <div className="d-flex flex-row justify-content-between">
                                    <label className="form-label fw-bold">
                                        Product Gallery
                                    </label>
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-sm"
                                        onClick={() => {
                                            fileUploadRef.current.click();
                                            setCurrentUpload("gallery");
                                        }}
                                        disabled={galleryPhotoUploading}
                                    >
                                        <i className="bi bi-upload mx-2"></i>
                                        {galleryPhotoUploading
                                            ? "Uploading ..."
                                            : "Upload New Photo"}
                                    </button>
                                </div>
                                <div>
                                    <Row>
                                        {productGallery.map(
                                            (image: string, index: number) => (
                                                <Col
                                                    xs="4"
                                                    className="text-end"
                                                >
                                                    <button
                                                        type="button"
                                                        className="btn btn-grey btn-sm mx-1"
                                                        onClick={() => {
                                                            productGallery.splice(
                                                                index,
                                                                1
                                                            );
                                                            setProductGallery([
                                                                ...productGallery,
                                                            ]);
                                                        }}
                                                    >
                                                        <i
                                                            className="bi bi-trash"
                                                            style={{
                                                                fontSize: 10,
                                                            }}
                                                        ></i>
                                                    </button>
                                                    <img
                                                        src={image}
                                                        width="100%"
                                                        className="rounded-1"
                                                    />
                                                </Col>
                                            )
                                        )}
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            )}

            <input
                type="file"
                ref={fileUploadRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
            />
        </div>
    );
};

export default CreateVehicle;
